module.exports = __webpack_public_path__ + "img/GayPenguin.e3d8e9e1.png";